import './App.css';
import Weather from "./Weather"


 function App() {
  return (
    <div className="App">
        <div className="container">
     
    <Weather defaultCity="Kharkiv"/> 
    <br />
      <footer>Open-source code by <a href="https://stately-blini-33ec0a.netlify.app" target="_blank" rel="noreferrer">Yana Diukarieva</a> on <a href="https://github.com/YasiaDi/weather-react" target="_blank" rel="noreferrer">Github</a>
      </footer>
      </div>
    </div>
  
  );
}

export default App;
